import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "italic text-gray-700 text-sm" }, "Please enter the first 3 letters of the users surname:", -1);
const _hoisted_3 = { class: "mt-1 flex rounded-md shadow-sm" };
const _hoisted_4 = { class: "relative flex items-stretch flex-grow focus-within:z-10" };
const _hoisted_5 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "Search", -1);
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "mt-4 relative" };
const _hoisted_11 = { class: "block truncate" };
const _hoisted_12 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" };
const _hoisted_13 = { class: "flex justify-end" };
const _hoisted_14 = {
    key: 1,
    class: "text-center mt-2 text-gray-700"
};
const _hoisted_15 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_16 = {
    key: 1,
    class: "mt-1 sm:mt-0 sm:col-span-2"
};
const _hoisted_17 = { class: "max-w-lg flex rounded-md" };
const _hoisted_18 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UsersIcon = _resolveComponent("UsersIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_SelectorIcon = _resolveComponent("SelectorIcon");
    const _component_ListboxButton = _resolveComponent("ListboxButton");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ListboxOption = _resolveComponent("ListboxOption");
    const _component_ListboxOptions = _resolveComponent("ListboxOptions");
    const _component_Listbox = _resolveComponent("Listbox");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", null, [
        (!_ctx.readOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_UsersIcon, {
                                    class: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "userSearch",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userSearch) = $event)),
                                type: "userSearch",
                                name: "userSearch",
                                autocomplete: "off",
                                placeholder: "Search for a user",
                                class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border border-gray-300",
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('blur'))),
                                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.fetchRequestedUsers && _ctx.fetchRequestedUsers(...args)), ["stop", "prevent"]), ["enter"]))
                            }, null, 544), [
                                [_vModelText, _ctx.userSearch]
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            type: "button",
                            class: "-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:cursor-not-allowed disabled:text-gray-400 disabled:bg-gray-200",
                            disabled: _ctx.userSearch.length <= 2,
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.fetchRequestedUsers && _ctx.fetchRequestedUsers(...args)))
                        }, [
                            _createVNode(_component_SearchIcon, {
                                class: "h-5 w-5 text-gray-400",
                                "aria-hidden": "true"
                            }),
                            _createTextVNode(),
                            _hoisted_7
                        ], 8, _hoisted_6)
                    ])
                ]),
                _createTextVNode(),
                (_ctx.users)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.notArchived.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_Listbox, {
                                    modelValue: _ctx.selected,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.selected) = $event)),
                                    as: "div"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_ListboxButton, { class: "bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selected?.Title), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("span", _hoisted_12, [
                                                        _createVNode(_component_SelectorIcon, {
                                                            class: "h-5 w-5 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    ])
                                                ]),
                                                _: 1
                                            }),
                                            _createTextVNode(),
                                            _createVNode(_Transition, {
                                                "leave-active-class": "transition ease-in duration-100",
                                                "leave-from-class": "opacity-100",
                                                "leave-to-class": "opacity-0"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notArchived, (user) => {
                                                                return (_openBlock(), _createBlock(_component_ListboxOption, {
                                                                    key: user.userID ?? user.id,
                                                                    as: "template",
                                                                    value: user
                                                                }, {
                                                                    default: _withCtx(({ active, selected: isSelected }) => [
                                                                        _createElementVNode("li", {
                                                                            class: _normalizeClass([active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9'])
                                                                        }, [
                                                                            _createElementVNode("span", {
                                                                                class: _normalizeClass([isSelected ? 'font-semibold' : 'font-normal', 'block truncate'])
                                                                            }, _toDisplayString(user.Title), 3),
                                                                            _createTextVNode(),
                                                                            isSelected
                                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                                    key: 0,
                                                                                    class: _normalizeClass([active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4'])
                                                                                }, [
                                                                                    _createVNode(_component_CheckIcon, {
                                                                                        class: "h-5 w-5",
                                                                                        "aria-hidden": "true"
                                                                                    })
                                                                                ], 2))
                                                                                : _createCommentVNode("", true)
                                                                        ], 2)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["value"]));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "mt-4 mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
                                                    //@ts-ignore
                                                    (...args) => (_ctx.selectedUser && _ctx.selectedUser(...args)), ["prevent"]))
                                                }, "Select")
                                            ])
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14, "\n          No results found...\n        "))
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.errors?.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "\n        * " + _toDisplayString(_ctx.errors[0].$message), 1))
                    : _createCommentVNode("", true)
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("input", {
                        id: "approval",
                        type: "email",
                        name: "approval",
                        value: _ctx.selectedEmail,
                        disabled: "",
                        class: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 disabled:cursor-not-allowed disabled:bg-gray-200"
                    }, null, 8, _hoisted_18),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "text-gray-400 hover:text-gray-800 ml-2",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)), ["prevent"]))
                    }, [
                        _createVNode(_component_XIcon, { class: "h-5 w-5" })
                    ])
                ])
            ]))
    ]));
}
